<mat-dialog-content class="modal-content-monitor">
  <div class="flex flex-row gap-2">
    <div class="flex flex-row items-center justify-center mr-3">
      <div class="circle self-center"></div>
      {{ data.id }}
    </div>
    <p class="whitespace-nowrap">
      <span class="font-semibold">{{ data.subRoute.code }}</span> -
      {{ data.subRoute.name }}
    </p>
    <mat-progress-bar
      mode="determinate"
      [value]="30"
      matTooltip="30%"
      class="progress-bar-monitor h-6 ml-4"
    ></mat-progress-bar>
  </div>
  <div class="flex flex-row mt-3 max-w-full modal-container-monitor">
    <ng-container *ngIf="isVisibleMap">
      <div
        class="h-full flex flex-col w-full md:w-auto transition-all duration-500"
      >
        <div class="flex flex-row mb-3 px-3 w-full justify-between">
          <div class="flex items-center pr-3">
            <div class="bg-indigo-100 px-3 py-2 rounded">
              <mat-icon
                class="text-indigo-500"
                svgIcon="heroicons_outline:flag"
              ></mat-icon>
            </div>

            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">Hora Inicio</p>
              <p class="text-md">
                {{
                  data.dateHourStart
                    ? (data.dateHourStart | date: "HH:mm:ss")
                    : "-"
                }}
              </p>
            </div>
          </div>
          <!--
        
            <div class="flex flex-row items-center rounded px-3">
          <div class="pt-2">
            <mat-icon color="primary" svgIcon="heroicons_outline:flag" />
          </div>
          <span class="pl-2 font-semibold">
            {{
              data.dateHourStart.real
                ? (data.dateHourStart.real | date: "HH:mm:ss")
                : "-"
            }}</span
          >
        </div>
        -->
          <div class="flex items-center pr-3">
            <div class="bg-violet-100 px-3 py-2 rounded">
              <mat-icon
                class="text-violet-500"
                svgIcon="heroicons_solid:flag"
              ></mat-icon>
            </div>

            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">Hora Fin</p>
              <p class="text-md">
                {{
                  data.dateHourEnd ? (data.dateHourEnd | date: "HH:mm:ss") : "-"
                }}
              </p>
            </div>
          </div>

          <div class="flex items-center pr-3">
            <div class="bg-orange-100 px-3 py-2 rounded">
              <mat-icon
                class="text-orange-500"
                svgIcon="heroicons_outline:map"
              ></mat-icon>
            </div>

            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">Recorrido</p>
              <p class="text-md">0 km</p>
            </div>
          </div>

          <div class="p-4 flex items-center">
            <div class="bg-green-100 px-3 py-2 rounded">
              <mat-icon
                class="text-green-500"
                svgIcon="heroicons_outline:map-pin"
              ></mat-icon>
            </div>

            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">Entregas</p>
              <p class="text-md">
                {{ data.size }}
              </p>
            </div>
          </div>

          <!--
             <button mat-stroked-button color="primary">
              <mat-icon svgIcon="heroicons_outline:map-pin" />
              <span class="pl-2"> 16</span>
            </button>
            -->
        </div>
        <div class="h-[420px] rounded-sm">
          <app-agenda-map [visits]="data?.visits"></app-agenda-map>
        </div>
      </div>
    </ng-container>
    <div class="flex justify-center items-center button-map-hidden">
      <button
        (click)="onMapVisible()"
        class="py-10 bg-white shadow-md rounded-lg w-6 hover:bg-gray-50"
      >
        <mat-icon
          [svgIcon]="
            isVisibleMap
              ? 'heroicons_solid:chevron-right'
              : 'heroicons_solid:chevron-left'
          "
          class="text-xs"
        ></mat-icon>
      </button>
    </div>
    <div class="flex-1 pl-3 mt-3">
      <div class="flex flex-row gap-2 justify-around">
        <div>
          <P class="whitespace-nowrap font-semibold">
            {{ data?.statusDelivery?.punctual }}
            <span class="text-primary">PUNTUALES</span></P
          >
          <P>En proceso</P>
        </div>
        <div>
          <P class="whitespace-nowrap font-semibold">
            {{ data?.statusDelivery?.delay }}
            <span class="text-yellow-500">DEMORAS</span></P
          >
          <P>En proceso</P>
        </div>
        <div>
          <P class="whitespace-nowrap font-semibold">
            {{ data?.statusDelivery?.delivery }}
            <span class="text-green-500">ENTREGA</span></P
          >
          <P>Realizada</P>
        </div>
        <div>
          <P class="whitespace-nowrap font-semibold">
            {{ data?.statusDelivery?.calcel }}
            <span class="text-red-500">CANCELADAS</span></P
          >
          <P>Realizada</P>
        </div>
      </div>
      <div class="flex flex-row justify-around">
        <div class="p-4 flex items-center">
          <div class="bg-indigo-100 px-3 py-2 rounded">
            <mat-icon
              class="text-indigo-500"
              svgIcon="heroicons_outline:flag"
            ></mat-icon>
          </div>

          <div class="ml-4 w-full">
            <p class="text-gray-600 text-sm">Fecha Inicio</p>
            <p class="text-md">
              {{
                data?.dateHourStart
                  ? (data?.dateHourStart | date: "dd-MM-yyyy HH:mm")
                  : "-"
              }}
            </p>
          </div>
        </div>

        <div class="p-4 flex items-center">
          <div class="bg-violet-100 px-3 py-2 rounded">
            <mat-icon
              class="text-violet-500"
              svgIcon="heroicons_solid:flag"
            ></mat-icon>
          </div>

          <div class="ml-4 w-full">
            <p class="text-gray-600 text-sm">Fecha Fin</p>
            <p class="text-md">
              {{
                data?.dateHourStart
                  ? (data?.dateHourEnd | date: "dd-MM-yyyy HH:mm")
                  : "-"
              }}
            </p>
          </div>
        </div>
      </div>

      <div class="overflow-y-auto max-h-90">
        <div *ngFor="let visit of data.documents; let i = index">
          <!-- Encabezado del pedido -->
          <div
            class="flex-col gap-2 overflow-hidden justify-between flex cursor-pointer mb-2"
          >
            <div
              class="flex items-center pr-3 hover:bg-gray-50"
              (click)="toggleOrder(visit)"
            >
              <!-- Círculo de color dinámico -->
              <div class="flex flex-row items-center w-full rounded-sm">
                <div
                  [class]="
                    'w-[6px] h-[80px] text-white ' +
                    visit?.statusDelivery?.color
                  "
                ></div>
                <div class="flex flex-col ml-3 flex-1">
                  <div class="flex flex-row w-full justify-between">
                    <p class="uppercase flex flex-col">
                      <span class="table-text-code text-xs font-semibold">
                        {{ visit?.shipTo.externalKeys.code }}
                      </span>
                      <span class="text-sm">
                        {{ visit?.shipTo?.name }}
                      </span>
                    </p>
                    <p class="flex flex-row gap-2 text-sm items-center">
                      <mat-icon
                        color="primary"
                        svgIcon="heroicons_outline:calendar"
                      />
                      {{
                        visit.deliveryDateTime
                          ? (visit.deliveryDateTime | date: "dd-MM-yyyy HH:mm")
                          : "-"
                      }}
                    </p>
                  </div>
                  <p class="flex flex-row gap-2 text-sm">
                    Direccion:
                    <mat-icon
                      color="primary"
                      svgIcon="heroicons_outline:map-pin"
                    />
                    {{ visit.address.address ?? " - " }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Contenido del pedido -->
          <div
            class="p-4 transition-all duration-300"
            [hidden]="orderSelect?._id !== visit?._id"
          >
            <ng-container
              *ngTemplateOutlet="
                rowDetailsVisit;
                context: {
                  visit,
                }
              "
            >
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<div class="flex justify-end">
  <button class="m-2 p-2 font-semibold" mat-dialog-close>Cerrar</button>
</div>

<ng-template #rowDetailsVisit>
  <div class="flex-1 flex flex-col h-full overflow-hidden">
    <div class="flex items-start pb-2 bx-10">
      <div class="flex flex-col space-y-1 w-[50%] pr-10">
        <div class="flex flex-row justify-around text-md">
          <span class="font-semibold">Cnt. Carga:</span>
          <span
            >{{ orderSelect?.loan?.value | number: "1.3-3" }}
            <span class="font-semibold">{{
              orderSelect?.loan?.unit
            }}</span></span
          >
        </div>
        <div class="flex flex-row justify-around text-md">
          <span class="font-semibold">Nro. Entrega:</span>
          <span>{{ orderSelect?.serial ?? " - " }}</span>
        </div>
      </div>
      <div class="flex flex-col space-y-1 text-right w-[50%]">
        <div class="flex flex-row justify-around text-md">
          <span class="font-semibold">Total:</span>
          <span
            >{{ orderSelect?.total | decimalFormat }}
            <span class="font-semibold">{{
              orderSelect?.currency?.name
            }}</span></span
          >
        </div>
        <div class="flex flex-row justify-around text-md">
          <span class="font-semibold">Nro. Factura:</span>
          <span>{{ orderSelect?.nextTransactions?.serial ?? " - " }}</span>
        </div>
      </div>
    </div>
    <div class="flex-1 flex flex-col overflow-hidden mb-6">
      <!-- Header -->
      <div
        class="overflow-y-auto max-h-96 sticky top-0 z-10 bg-gray-100 dark:bg-gray-900"
      >
        <table
          class="overflow-y-visible mat-elevation-z"
          mat-table
          [dataSource]="dataSourceVisit"
          matSort
          #sortSubDocument="matSort"
          matSortDisableClear
          multiTemplateDataRows
        >
          <!-- Material -->
          <ng-container matColumnDef="material">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="text-left whitespace-nowrap"
            >
              <p class="px-6">Material</p>
            </th>
            <td
              mat-cell
              *matCellDef="let data"
              class="text-left text-uppercase flex flex-row mt-4 whitespace-nowrap"
            >
              <p class="px-6 text-sm">
                <span class="table-text-code font-semibold">{{
                  data?.material?.code
                }}</span
                ><br />
                {{ data?.material?.name }}
              </p>
            </td>
          </ng-container>

          <!--  Precio -->
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-right">
              Precio
            </th>
            <td mat-cell *matCellDef="let data" class="text-right text-sm">
              <p class="px-6 text-right text-sm">
                {{ data?.subTotal | decimalFormat }}
              </p>
            </td>
          </ng-container>

          <!-- Carga -->
          <ng-container matColumnDef="cntLoad">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="px-6 text-right"
            >
              Carga
            </th>
            <td mat-cell *matCellDef="let data" class="px-6 text-right text-sm">
              {{ data?.baseQuantity | number: "1.3-3" }}
              {{ data?.baseUnitOfMeasure?.code }}
            </td>
          </ng-container>

          <!-- Numero de Documento -->
          <ng-container matColumnDef="noDelivery">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="px-6 whitespace-nowrap"
            >
              Nro. Documento
            </th>
            <td
              mat-cell
              *matCellDef="let data"
              class="whitespace-nowrap uppercase"
            >
              <p class="px-6">
                {{ data?.serial ?? " - " }}
              </p>
            </td>
          </ng-container>

          <!-- Header Row -->
          <tr
            mat-header-row
            *matHeaderRowDef="displayColumsVisit"
            class="bg-gray-100 dark:bg-gray-900"
          ></tr>
          <!-- Fila principal -->
          <tr
            mat-row
            *matRowDef="let row; columns: displayColumsVisit"
            class="border-b"
          ></tr>
        </table>
      </div>
      <div
        *ngIf="dataSourceVisit?.data?.length === 0"
        class="border-t p-8 text-center text-1xl sm:p-10"
      >
        Lo sentimos, no hay registros para mostrar.
      </div>
    </div>
  </div>
</ng-template>
